import React, { forwardRef } from "react";

import { cn } from "~/services/shadcn";

type EmptyProps = {
  children: React.ReactNode;
  className?: string;
};

export const Empty = forwardRef<HTMLDivElement, EmptyProps>(function Empty(
  { children, className },
  ref,
) {
  return (
    <div
      ref={ref}
      className={cn(
        "flex items-center space-x-2 text-center text-sm font-semibold md:text-lg",
        className,
      )}
    >
      {children}
    </div>
  );
});
